import z from "zod";

export const objectiveActionsSchema = z.object({
  display_name: z
    .string({ message: 'Campo obrigatório' })
    .trim()
    .min(3, { message: 'Tamanho mínimo: 3 caracteres' }),
  description: z
    .string({ message: 'Campo obrigatório' })
    .trim()
    .min(8, { message: 'Tamanho mínimo: 8 caracteres' }),
});

export type ObjectiveActionsValidationSchema = z.infer<typeof objectiveActionsSchema>;
